import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.page.html',
  styleUrls: ['./help-modal.page.scss'],
})
export class HelpModalPage implements OnInit {

  constructor(
    private modalCtrl: ModalController,
    private storage: Storage
  ) { }

  ngOnInit() {
  }

  close() {
    this.modalCtrl.dismiss().then(() => {
      this.storage.set('checkScanHelp', true);
    });
  }

}
